<template>
  <modal v-model="show"
         max-width="400"
         :has-padding="false">

    <div class="close"
         @click="close">&times;</div>
    
    <app-button v-if="!user"
                :class="user ? '' : `btn btn-primary btn-extra-round`"
                slot="activator"
                :label="$t('message.users.message.registerNewUser')"
                v-tooltip.left="!this.canCreateUsers ? $t('message.generics.message.funcionalityNotActive') : ''"                                
                :disabled="!canCreateUsers"
                :allowed="!!canCreateUsers"
                :primary="canCreateUsers"
                @click="reset()"></app-button>

    <div :key="form.id">
      <users-creation-form-body ref="body"
                                v-model="form"
                                :is-edit="!!user"
                                :show="show"
                                :user="user"
                                @alter-permission="$emit('alter-permission')"
                                @valid="save" />

      <div class="card-footer">
        <button class="btn btn-primary btn-round"
                @click="validate()">
          {{ user ? this.$t('message.generics.message.save') : this.$t('message.generics.message.register') }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/components/generic/Modal";
import AppButton from "@/components/generic/button/Button";
import EventBus from "@packages/event-bus/index";
import UsersCreationFormBody from "@views/users/components/UsersCreationFormBody";

export default {
  components: {
    UsersCreationFormBody,
    Modal,
    AppButton
  },

  data() {
    return {
      show: false,
      form: {},
      isEdit: false,
      updateId: undefined,
      timezoneOptions: [],
    };
  },

  props: {
    user: {
      type: Object,
    },
  },

  computed: {
    isAdmin() {
      return this.$store.state.users.admin;
    },
    isPartner() {
      return (
        this.$store.state.users.user &&
        this.$store.state.users.user.tipo === "PARCEIRO"
      );
    },    
    userStored() {
      return this.$store.state.users.user;
    },

    permissions() {
      return this.userStored.permissions;
    },

    canCreateUsers() {
      return (this.isAdmin || this.isPartner) ? true : this.permissions.find((x) => x === "ALLOW_CREATE_USERS");
    },
  },

  methods: {
    close() {
      this.show = false;
    },
    async edit() {
      this.form = {
        name: this.user.name,
        email: this.user.login,
        parentId:
          this.user.parentId !== this.user.id ? this.user.parentId : undefined,
        phoneNumber: this.user.phoneNumber,
        role: this.user.role
      };

      this.show = true;
    },
    async reset() {
      this.form = {};
      this.show= true
    },
    validate() {
      this.$refs.body.validate();
    },
    async save() {
      EventBus.$emit("SHOW_SPINNER");

      try {
        if (!this.user) {
          await this.$api.userLogin.create({
            ...this.form,
          });

          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: this.$t("message.successMessages.message.userCreated"),
            timeout: 2000,
          });
          this.$emit("created");
        } else {
          const newUser = await this.$api.userLogin.edit({
            id: this.user.id,
            ...this.form,
          });

          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: this.$t("message.successMessages.message.userEdited"),
            timeout: 2000,
          });

          this.$emit("updated", newUser);
        }

        this.show = false;
      } catch (error) {
        console.log(error);
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.card-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 15px;

  .btn {
    margin: 15px;
  }
}

.modal-round .v-card .card-body {
  min-height: 160px;
  border-radius: 20px;
}
</style>
